import { Fetch } from "./util/InterceptedFetch";
import { BuildUri } from "./util/BuildUri";

import { AllConfiguration } from "../model/Configuration";
import { AttachmentFile, AttachmentLog } from "src/model/Attachment";

export class ConfigurationEndpoints {
    constructor(private fetch: Fetch) {}

    getConfiguration(): Promise<AllConfiguration> {
        return this.fetch(BuildUri("/configuration"));
    }

    getSaleBidderPhotos(saleId: number): Promise<AttachmentLog> {
        return this.fetch(BuildUri("/configuration/sale/{saleId}/photos", { saleId }));
    }
}



// WEBPACK FOOTER //
// ./src/endpoints/ConfigurationEndpoints.ts